import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@sla-ng/core';
import { GenericInputHintModule } from '../../generic-input-hint/generic-input-hint.module';
import { GenericInputSlotModule } from '../../generic-input-slot/generic-input-slot.module';
import { GenericDecimalInputComponent } from './generic-decimal-input.component';

export * from './generic-decimal-input.component';

@NgModule({
    declarations: [ GenericDecimalInputComponent ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatIconModule,
        ReactiveFormsModule,
        MatInputModule,
        MatProgressBarModule,
        GenericInputHintModule,
        GenericInputSlotModule,
        TranslateModule,
        CoreModule,
        MatButtonModule,
    ],
    exports: [
        GenericDecimalInputComponent,
    ],
})
export class GenericDecimalInputModule {
}
